var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"customCode"},_vm._l((_vm.types),function(type,idx){return _c('CodeType',{key:idx,attrs:{"label":_vm.getLabel(type),"type":type,"codeBase":_vm.codeBase[type],"isLast":type === 'html'}})}),1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-301abc36","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Toolbar/CustomCode/index.vue
// module id = null
// module chunks = 